"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentStatusForUpdate = exports.EventCommentStatus = exports.ResultType = exports.PushKind = exports.ArrivedFrom = exports.ComponentSource = exports.ComponentNames = exports.ScreenNames = exports.UserRole = exports.ClubVersion = exports.Systems = exports.DataHubEntities = exports.Platform = exports.ActionsName = void 0;
var ActionsName;
(function (ActionsName) {
    ActionsName["VIEW_MODERATION"] = "view_moderation";
    ActionsName["TRY_COMMENTS_CLASS_ANSWER"] = "try_comments_class_answer";
    ActionsName["TRY_COMMENTS_CLASS_APPROVE"] = "try_comments_class_approve";
    ActionsName["TRY_COMMENTS_CLASS_DISAPPROVE"] = "try_comments_class_disapprove";
    ActionsName["TRY_COMMENTS_CLASS_HIDDEN"] = "try_comments_class_hidden";
    ActionsName["TRY_COMMENTS_CLASS_SPAM_CONFIRMED"] = "try_comments_class_spam";
    ActionsName["CLICK_FREE_MODULE_TOGGLE"] = "click_free_module_toggle";
    ActionsName["CLICK_FREE_MODULE_ACTIVATION"] = "click_free_module_activation";
    ActionsName["CLICK_FREE_MODULE_CLOSE"] = "click_free_module_close";
    ActionsName["CLICK_FREE_MODULE_GIVE_UP"] = "click_free_module_give_up";
    ActionsName["CLICK_FREE_MODULE_GO_BACK"] = "click_free_module_go_back";
    ActionsName["CLICK_FREE_MODULE_SAVE"] = "click_free_module_save";
    ActionsName["CLICK_NEW_MODERATION_CLOSE"] = "click_new_moderation_close";
    ActionsName["CLICK_NEW_MODERATION_VIEW"] = "click_new_moderation_view";
    ActionsName["CLICK_FREE_MODULE_CONFIG"] = "click_sales_page_config";
    ActionsName["CLICK_FREE_MODULE_DEFAULT"] = "click_sales_page_default";
    ActionsName["CLICK_NEW_MODERATION_BANNER"] = "click_new_moderation_banner";
    ActionsName["VIEW_FREE_MODULE_MODAL"] = "view_free_module_modal";
    ActionsName["VIEW_CREATE_AD"] = "view_create_ad";
    ActionsName["CLICK_CREATE_AD"] = "click_create_ad";
    ActionsName["VIEW_CREATE_MODULE"] = "view_create_module";
    ActionsName["CLICK_CREATE_MODULE"] = "click_create_module";
    ActionsName["CLICK_ACCESS_HOTMART_CLUB"] = "click_access_hotmartclub";
    ActionsName["VIEW_CREATE_DRIPPING"] = "view_create_dripping";
    ActionsName["VIEW_CREATE_DRIPPING_ALERTS"] = "view_create_dripping_alerts";
    ActionsName["VIEW_DRIPPING_LEARN_MORE"] = "view_dripping_learn_more";
    ActionsName["CLICK_DELETE_CONTENT"] = "click_delete_content";
    ActionsName["VIEW_CONTENT_CREATE"] = "view_content_create";
    ActionsName["VIEW_CONTENT_EDIT"] = "view_content_edit";
    ActionsName["VIEW_DEVICE_MEDIA_UPLOAD"] = "view_device_media_upload";
    ActionsName["VIEW_MEMBERSHIP_MEDIA_UPLOAD"] = "view_membership_media_upload";
    ActionsName["TRY_MEDIA_UPLOAD"] = "try_media_upload";
    ActionsName["TRY_FILE_UPLOAD"] = "try_file_upload";
    ActionsName["TRY_GENERATE_SUBTITLES"] = "try_generate_subtitles";
    ActionsName["VIEW_UPLOAD_SUBTITLES"] = "view_upload_subtitles";
    ActionsName["VIEW_EDIT_SUBTITLES"] = "view_edit_subtitles";
    ActionsName["TRY_TRANSLATE_SUBTITLES"] = "try_translate_subtitles";
    ActionsName["TRY_DOWNLOAD_SUBTITLES"] = "try_download_subtitles";
    ActionsName["TRY_DELETE_SUBTITLES"] = "try_delete_subtitles";
    ActionsName["TRY_UPLOAD_SUBTITLES"] = "try_upload_subtitles";
    ActionsName["TRY_CREATE_URL_READ"] = "try_create_url_read";
    ActionsName["VIEW_DEVICE_FILE_UPLOAD"] = "view_device_file_upload";
    ActionsName["VIEW_MEMBERSHIP_FILE_UPLOAD"] = "view_membership_file_upload";
    ActionsName["TRY_EDIT_VIDEO_THUMBNAIL"] = "try_edit_video_thumbnail";
    ActionsName["CLICK_MIGRATE_NEW_CLUB"] = "click_migrate_new_club";
    ActionsName["CLICK_MIGRATION_MODAL_CLOSE"] = "click_migration_modal_close";
    ActionsName["VIEW_CREATE_MENTORSHIP"] = "view_create_mentorship";
    ActionsName["VIEW_BULK_DRIPPING_CREATE"] = "view_bulk_dripping_create";
})(ActionsName || (exports.ActionsName = ActionsName = {}));
var Platform;
(function (Platform) {
    Platform["WEB"] = "WEB";
})(Platform || (exports.Platform = Platform = {}));
var DataHubEntities;
(function (DataHubEntities) {
    DataHubEntities["ADMIN"] = "admin";
})(DataHubEntities || (exports.DataHubEntities = DataHubEntities = {}));
var Systems;
(function (Systems) {
    Systems["HOTMART_CLUB"] = "hotmart_club";
})(Systems || (exports.Systems = Systems = {}));
var ClubVersion;
(function (ClubVersion) {
    ClubVersion["MEMBERSHIP"] = "MEMBERSHIP";
    ClubVersion["OLD_CLUB_ADMIN"] = "OLD_CLUB_ADMIN";
})(ClubVersion || (exports.ClubVersion = ClubVersion = {}));
var UserRole;
(function (UserRole) {
    UserRole["OWNER"] = "OWNER";
    UserRole["MODERATOR"] = "MODERATOR";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["CONSUMER"] = "CONSUMER";
})(UserRole || (exports.UserRole = UserRole = {}));
var ScreenNames;
(function (ScreenNames) {
    ScreenNames["HOME"] = "home";
    ScreenNames["PREVIEW_PENDING_COMMENT"] = "previewPendingComment";
    ScreenNames["NOT_APP_EVENT"] = "NOT_APP_EVENT";
    ScreenNames["OLD_MODERATION"] = "OLD_MODERATION";
    ScreenNames["CONFIG_MANAGER"] = "CONFIG_MANAGER";
})(ScreenNames || (exports.ScreenNames = ScreenNames = {}));
var ComponentNames;
(function (ComponentNames) {
    ComponentNames["PREVIEW_PENDING_COMMENT"] = "PreviewPendingComment";
    ComponentNames["HOME"] = "Home";
    ComponentNames["BUTTON_CLOSE_MODAL"] = "BUTTON_CLOSE_MODAL";
    ComponentNames["BUTTON_WANT_KNOW"] = "BUTTON_WANT_KNOW";
    ComponentNames["BUTTON_STATUS_APPROVE"] = "BUTTON_STATUS_APPROVE";
    ComponentNames["BUTTON_STATUS_HIDDEN"] = "BUTTON_STATUS_HIDDEN";
    ComponentNames["BUTTON_STATUS_SPAM"] = "BUTTON_STATUS_SPAM";
    ComponentNames["BUTTON_STATUS_SPAM_CONFIRMED"] = "BUTTON_STATUS_SPAM_CONFIRMED";
    ComponentNames["BUTTON_DISCLAIMER_BANNER"] = "BUTTON_DISCLAIMER_BANNER";
    ComponentNames["BUTTON_ACCESS_HOTMART_CLUB"] = "BUTTON_ACCESS_HOTMART_CLUB";
    ComponentNames["BUTTON_DELETE_CONTENT"] = "BUTTON_DELETE_CONTENT";
    ComponentNames["BUTTON_DELETE_PAGE"] = "BUTTON_DELETE_PAGE";
    ComponentNames["BUTTON_NEW_CLUB_MIGRATION_MODAL"] = "BUTTON_NEW_CLUB_MIGRATION_MODAL";
    ComponentNames["BUTTON_CLOSE_NEW_CLUB_MIGRATION_MODAL"] = "BUTTON_CLOSE_NEW_CLUB_MIGRATION_MODAL";
    ComponentNames["BUTTON_NEW_CLUB_MIGRATION_ALERT"] = "BUTTON_NEW_CLUB_MIGRATION_ALERT";
})(ComponentNames || (exports.ComponentNames = ComponentNames = {}));
var ComponentSource;
(function (ComponentSource) {
    ComponentSource["ACTION_BAR_STATUS"] = "ACTION_BAR_STATUS";
    ComponentSource["DROPDOWN_STATUS"] = "DROPDOWN_STATUS";
    ComponentSource["MODAL_REDIRECT_NEW_MODERATION"] = "MODAL_REDIRECT_NEW_MODERATION";
    ComponentSource["PAGE_OLD_MODERATION"] = "PAGE_OLD_MODERATION";
})(ComponentSource || (exports.ComponentSource = ComponentSource = {}));
var ArrivedFrom;
(function (ArrivedFrom) {
    ArrivedFrom["HOME"] = "HOME";
    ArrivedFrom["MEMBERSHIP_ADMIN"] = "MEMBERSHIP_ADMIN";
    ArrivedFrom["MODULE_EDITOR"] = "MODULE_EDITOR";
    ArrivedFrom["CONTENT_PAGE_EDITOR"] = "CONTENT_PAGE_EDITOR";
    ArrivedFrom["NEW_DRIPPING_BUTTON"] = "NEW_DRIPPING_BUTTON";
    ArrivedFrom["DRIPPING_LEARN_MORE"] = "DRIPPING_LEARN_MORE";
    ArrivedFrom["DRIPPING_FORM"] = "DRIPPING_FORM";
    ArrivedFrom["CONTENT_LIST"] = "CONTENT_LIST";
})(ArrivedFrom || (exports.ArrivedFrom = ArrivedFrom = {}));
var PushKind;
(function (PushKind) {
    PushKind["NOT_PUSH_EVENT"] = "NOT_PUSH_EVENT";
})(PushKind || (exports.PushKind = PushKind = {}));
var ResultType;
(function (ResultType) {
    ResultType["SUCCESS"] = "SUCCESSFUL";
    ResultType["FAILURE"] = "FAILURE";
    ResultType["FAILURE_DESCRIPTION"] = "NOT_FAILURE_RESULT_EVENT";
})(ResultType || (exports.ResultType = ResultType = {}));
var EventCommentStatus;
(function (EventCommentStatus) {
    EventCommentStatus["APPROVE"] = "APPROVE";
    EventCommentStatus["HIDDEN"] = "HIDDEN";
    EventCommentStatus["SPAM_CONFIRMED"] = "SPAM_CONFIRMED";
})(EventCommentStatus || (exports.EventCommentStatus = EventCommentStatus = {}));
var CommentStatusForUpdate;
(function (CommentStatusForUpdate) {
    CommentStatusForUpdate[CommentStatusForUpdate["AWAITING_MODERATION"] = 0] = "AWAITING_MODERATION";
    CommentStatusForUpdate[CommentStatusForUpdate["APPROVED"] = 1] = "APPROVED";
    CommentStatusForUpdate[CommentStatusForUpdate["DELETED"] = 2] = "DELETED";
    CommentStatusForUpdate[CommentStatusForUpdate["EDITING"] = 3] = "EDITING";
    CommentStatusForUpdate[CommentStatusForUpdate["SPAM"] = 4] = "SPAM";
    CommentStatusForUpdate[CommentStatusForUpdate["SPAM_CONFIRMED"] = 5] = "SPAM_CONFIRMED";
    CommentStatusForUpdate[CommentStatusForUpdate["DISAPPROVED"] = 6] = "DISAPPROVED";
})(CommentStatusForUpdate || (exports.CommentStatusForUpdate = CommentStatusForUpdate = {}));
